import React from "react";

const DEVICE_TYPE_LABELS = {
  single_device: "This device only",
  multi_device: "Synced across devices",
};

function formatDate(value) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/** List item for a single registered passkey. */
const PasskeyCard = ({ passkey, onRevoke, isRevoking = false }) => {
  const createdAt = formatDate(passkey.created_at);
  const lastUsedAt = formatDate(passkey.last_used_at);
  const deviceTypeLabel =
    DEVICE_TYPE_LABELS[passkey.credential_device_type] || null;

  return (
    <div className="mfa-method-card passkey-card">
      <div style={{ flex: 1, marginRight: "12px" }}>
        <label
          style={{
            fontWeight: "500",
            margin: 0,
            color: "#1e293b",
            fontSize: "16px",
          }}
        >
          {passkey.friendly_name || "Passkey"}
        </label>
        <p style={{ color: "#64748b", marginTop: "4px", marginBottom: 0 }}>
          {[deviceTypeLabel, createdAt && `Added ${createdAt}`]
            .filter(Boolean)
            .join(" · ")}
          {lastUsedAt ? ` · Last used ${lastUsedAt}` : ""}
        </p>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <button
          type="button"
          className="cta-button secondary short"
          onClick={() => onRevoke(passkey)}
          disabled={isRevoking}
        >
          {isRevoking ? "Removing..." : "Remove"}
        </button>
      </div>
    </div>
  );
};

export default PasskeyCard;
